export const CATEGORIES_SERVICE = "CategoriesService";
